<template>
    <div>
        <!--<div class="top">-->
        <!--<img src="../assets/back.png" alt="" @click="back">-->
        <!--Back-->
        <!--</div>-->
        <div class="header">
            <div class="img">
                <img :src="videoSet.videoImg" alt="">
            </div>
            <div class="name-num">
                <p>{{videoSet.videoTitle}}</p>
                <p>共<span>{{videos.length!=0?videos.length:0}}</span>個視訊</p>
            </div>
        </div>
        <div class="content">
            <template v-for="(item,index) of videos">
                <a :href="item.externalLink">
                    <span v-if="item.externalLink">
                        <img :src="item.videoImg" alt="">
                    </span>
                </a>
                <span v-if="!item.externalLink"
                      :data-url="item.readVideoUrl"
                      :data-imgurl="item.videoImg"
                      :data-videotitle="item.videoTitle"
                      @click="playerVideo(item,'videoList')">
                    <img :src="item.videoImg" alt="">
                </span>
            </template>
        </div>
        <!-- <div v-if="videoFlag">
            <viewVideo @click="gotoHome($event)" :videoUrl="videoUrls" :videolist="videoList" :videotitle="videotitle" :imgurl="imgurl"></viewVideo>
        </div> -->
    </div>
</template>

<script>
    import viewVideo from "@/components/viewVideo.vue";
  export default {
    name: "videoList",
    components: {
        viewVideo
    },
    data() {
      return {
          videoId:'',
          videos:[],
          videoSet:{},
          videoFlag: false,
          videoUrls: "",
          videotitle:'',
          videoList: [],
          imgurl:'',
      }
    },
    methods: {
        getvideoList(){
            this.$axios.post('api/video/videoSet',{videoId:this.videoId}).then(res => {
                this.videos = res.data.data.videos;
                this.videoSet = res.data.data.videoSet
            })
        },
        playerVideo(data,routerUrl) {
            // this.videoUrls = currentTarget.dataset.url;
            // this.imgurl = currentTarget.dataset.imgurl;
            // this.videotitle = currentTarget.dataset.videotitle;
            const { readVideoUrl, videoUrl480, videoUrl720, videoUrl1080, videoImg, videoTitle, youtubeId } = data
            // this.videoUrls = readVideoUrl
            // this.imgurl = videoImg || ""
            // this.videoTitle = videoTitle || ""
            // this.videoList = [
            //     {
            //     name: '流畅',
            //     url: readVideoUrl
            //     },
            //     {
            //     name: '480p',
            //     url: videoUrl480
            //     },
            //     {
            //     name: '720p',
            //     url: videoUrl720
            //     },
            //     {
            //     name: '1080p',
            //     url: videoUrl1080
            //     },
            // ]
            // this.videoFlag = true;
            // let youtubeId = "OYeDNoLZRUU";
            this.$router.push({
                path:"/youtubeplayers",
                query:{
                    youtubeId:youtubeId,
                    videoUrls:readVideoUrl,
                    videotitle: videoTitle,
                    imgurl:videoImg,
                    routerUrl:routerUrl,
                    videoId:this.$route.query.videoId,
                    readVideoUrl:readVideoUrl,
                    videoUrl480:videoUrl480,
                    videoUrl720:videoUrl720,
                    videoUrl1080:videoUrl1080
                }
            })

        },
        gotoHome(target) {
            if (target.nodeName.toLowerCase() !== "video") {
                this.videoFlag = false;
            }
        },
    },
    created () {
        this.videoId = this.$route.query.videoId
    },
    mounted() {
        this.getvideoList()
    }
  }
</script>

<style scoped>
    .header {
        margin-top:.45rem;
        margin-left:.3rem;
        height: 1.95rem;
        display: flex;
    }
    .img{
        width:2rem;
        height:2rem;
        background: url("../assets/xiangCeBj.png")no-repeat;
        background-size: 100%;
        overflow:hidden;
        position: relative;
    }
    .img img{
        width:1.95rem;
        height:auto;
        position:absolute;
        top:50%;
        transform:translateY(-50%);
    }
    .name-num{
        position: relative;
        margin-left:.33rem;
    }
    .name-num p:first-of-type{
        position: absolute;
        width:4rem;
        top:0;
        font-size: .28rem;
        color:#333333;
    }
    .name-num p:last-of-type{
        width:4rem;
        font-size: .24rem;
        color:#999999;
        position: absolute;
        bottom:0;
    }
    .name-num p:last-of-type span{
        font-size: .36rem;
        color:#00A0EA;
        padding:0 .1rem;
    }
    .content{
        padding:0 .3rem;
        margin-top:.8rem;
        display: flex;
        flex-wrap: wrap;
    }
    .content span{
        display:inline-block;
        overflow:hidden;
        margin-bottom:.08rem;
        margin-right:.08rem;
        width:2.24rem;
        height:1.84rem;
        position: relative;
        border:1px solid #ddd;
        background: #3e3e3e;
    }
    .content span img{
        width:2.24rem;
        height:auto;
        position:absolute;
        top:50%;
        transform:translateY(-50%);
    }
    .content span:nth-of-type(3n){
        margin-right:0;
    }
</style>



// WEBPACK FOOTER //
// src/modules/AtomicChain/pages/videoList.vue